export const EVENT_OPEN_ONBOARDING_DIALOG = "OPEN_ONBOARDING_DIALOG";
export const EVENT_CLOSE_ONBOARDING_DIALOG = "CLOSE_ONBOARDING_DIALOG";
